import { useState, useEffect } from "react";

interface TagInputProps {
  value?: string;
  editable: boolean;
  onChange: (value: string) => void;
}

export default function TagInput({
  value = "",
  editable,
  onChange,
}: TagInputProps) {
  const [inputValue, setInputValue] = useState("");
  const [tags, setTags] = useState<string[]>([]);

  // sync when parent value changes
  useEffect(() => {
    setTags(
      value
        ? value
            .split(",")
            .map((v) => v.trim())
            .filter(Boolean)
        : [],
    );
  }, [value]);

  const addTag = () => {
    if (!inputValue.trim()) return;

    const updated = [...tags, inputValue.trim()];
    setTags(updated);
    setInputValue("");
    onChange(updated.join(","));
  };

  const removeTag = (index: number) => {
    const updated = tags.filter((_, i) => i !== index);
    setTags(updated);
    onChange(updated.join(","));
  };

  if (!editable) {
    return (
      <div className="flex flex-wrap gap-2 w-full">
        {tags?.map((option, optionIndex) => {
          return (
            <span
              key={optionIndex}
              className="font-normal text-[13px] capitalize inline-flex items-center rounded-md px-2 py-0.5 border transition-colors duration-200 bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-500/10 border-transparent  "
            >
              {option || (
                <span className="text-gray-400 italic">No answer provided</span>
              )}
            </span>
          );
        })}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-2 border border-gray-300 rounded-md px-2 py-1 focus-within:ring-2 focus-within:ring-[#20808d]">
      {tags.map((tag, index) => (
        <div
          key={index}
          className="flex items-center bg-gray-100  px-2 py-1 rounded-md text-sm"
        >
          <span>{tag}</span>
          <button
            type="button"
            onClick={() => removeTag(index)}
            className="ml-1 text-gray-400 hover:text-gray-600"
          >
            ✕
          </button>
        </div>
      ))}

      <input
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), addTag())}
        placeholder="Type and press Enter"
        className="flex-1 min-w-[120px] outline-none py-1 text-sm border-none focus:ring-0"
      />
    </div>
  );
}
